import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { UserProfileComponent } from './delete-user-profile/user-profile.component';
import { NavbarComponent } from './navbar/navbar.component';
import { childTokenGuard } from './Guards/child-token.guard';
import { companyGuard } from './Guards/company.guard';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ListAppointmentComponent } from './case-management/list-appointment/list-appointment.component';
import { CreateAppointmentComponent } from './case-management/create-appointment/create-appointment.component';
/* import { FollowupDetailsComponent } from './case-management/followup-details/followup-details.component'; */
import { BillingListComponent } from './case-management/billing-list/billing-list.component';
import { BillingCreateComponent } from './case-management/billing-create/billing-create.component';
import { ViewPdfComponent } from './case-management/view-pdf/view-pdf.component';
/* import { ViewPdfNewComponent } from './case-management/view-pdf-new/view-pdf-new.component'; */
import { ClosureReportComponent } from './case-management/closure-report/closure-report.component';
import { FilePreviewComponent } from './shared/file-preview/file-preview.component';
import { ViewBillFilesComponent } from './case-management/view-bill-files/view-bill-files.component';
import { CompanyNavbarComponent } from './company-login/company-navbar/company-navbar.component';
import { CompanyDashboardComponent } from './company-login/company-dashboard/company-dashboard.component';
import { CompanyApptListComponent } from './company-login/company-appt-list/company-appt-list.component';
import { CompanyApptDetailsComponent } from './company-login/company-appt-details/company-appt-details.component';
import { CompanyFollowupDetailsComponent } from './company-login/company-followup-details/company-followup-details.component';
import { ComposeMailComponent } from './mailbox/compose-mail/compose-mail.component';
import { MailListComponent } from './mailbox/mail-list/mail-list.component';
import { MailboxSidebarComponent } from './mailbox/mailbox-sidebar/mailbox-sidebar.component';
import { ViewMailComponent } from './mailbox/view-mail/view-mail.component';
import { FollowupReportComponent } from './case-management/followup-report/followup-report.component';
import { CallListComponent } from './case-management/call-list/call-list.component';
import { PrescriptionOldComponent } from './case-management/prescription-old/prescription-old.component';
import { PrescriptionComponent } from './case-management/prescription/prescription.component';
import { CaseDetailsComponent } from './case-management/case-details/case-details.component';
import { SendReportComponent } from './case-management/send-report/send-report.component';
import { VideoCallComponent } from './case-management/video-call/video-call.component';
import { ChatComponent } from './case-management/chat/chat.component';
import { TreatmentCostsComponent } from './case-management/quotation/treatment-costs/treatment-costs.component';
import { FollowupFCTComponent } from './case-management/followup-fct/followup-fct.component';
import { RegisteredCandidatesComponent } from './case-management/registered-candidates/registered-candidates.component';

const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'refresh', component: RefreshComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'terms-conditions', component: TermsConditionsComponent },
	{ path: 'delete-profile', component: UserProfileComponent },
	{ path: 'forgot-password', component: ResetPasswordNewComponent },
	{
		path: 'app', component: NavbarComponent, data: { breadcrumb: 'TopNavBar' }, canActivate: [childTokenGuard], children: [
			{ path: 'masters', loadChildren: () => import('./masters/masters.module').then(m => m.MastersModule), data: { animation: 1 } },
			{ path: 'dashboard', component: DashboardComponent, data: { animation: 2 } },
			{ path: 'list-appointment', component: ListAppointmentComponent, data: { animation: 6 } },
			{ path: 'book-appointment', component: CreateAppointmentComponent, data: { animation: 7 } },
			{ path: 'edit-case/:uId', component: CreateAppointmentComponent, data: { animation: 10.5 } },
			{
				path: 'appt-details/:chatAction/:uId/:folUpId', component: CaseDetailsComponent, data: { animation: 9 }, children: [
					{
						path: 'mails', component: MailListComponent, data: { breadcrumb: 'Mail List', animation: 47 }, children: [
							{
								path: ':mailId', component: ViewMailComponent, data: { breadcrumb: 'Mail', animation: 48 }
							}
						]
					},
				]
			},
			{
				path: 'send-report/:caseId/:followId', component: SendReportComponent, data: { animation: 9.5 }
			},
			{
				path: 'case-invoice/:uId', component: BillingListComponent, data: { animation: 11 }
			},
			{
				path: 'case-invoice-create/:uId', component: BillingCreateComponent, data: { animation: 12 }
			},
			{
				path: 'case-invoice-edit/:uId/:id', component: BillingCreateComponent, data: { animation: 13 }
			},
			{
				path: 'invoice-pdf/:type/:uId/:id', component: ViewPdfComponent, data: { animation: 14 }
			},
			/* {
				path: 'invoice-pdf-new/:type/:uId/:id', component: ViewPdfNewComponent, data: { animation: 14 }
			}, */
			{
				path: 'closure-report/:uId', component: ClosureReportComponent, data: { animation: 15 }
			},
			{
				path: 'bill-files/:uId', component: ViewBillFilesComponent, data: { animation: 16 }
			},
			{
				path: 'file-preview', component: FilePreviewComponent, data: { animation: 17 }
			},
			{
				path: 'prescription-old/:uId', component: PrescriptionOldComponent, data: { animation: 18 }
			},
			{
				path: 'prescription/:uId', component: PrescriptionComponent, data: { animation: 18 }
			},
			{
				path: 'followup-report/:caseId/:followId', component: FollowupReportComponent, data: { animation: 19 }
			},
			{
				path: 'call-list', component: CallListComponent, data: { animation: 19.5 }
			},
			{
				path: 'mailbox', component: MailboxSidebarComponent, data: { breadcrumb: 'Folder List', animation: 20 }, children: [
					{
						path: 'folder/:folder', component: MailListComponent, data: { breadcrumb: 'Mail List', animation: 21 }, children: [
							{
								path: ':mailId', component: ViewMailComponent, data: { breadcrumb: 'Mail', animation: 22 }
							}
						]
					},
					{
						path: 'compose', component: ComposeMailComponent, data: { breadcrumb: 'Compose', animation: 23 }
					},
				]
			},
			{
				path: 'video-call/:caseId/:followId/:userId', component: VideoCallComponent, data: { animation: 24 }
			},
			{
				path: 'chat/:caseId/:followId/:userId', component: ChatComponent, data: { animation: 25 }
			},
			{
				path: 'treatment-costs', component: TreatmentCostsComponent, data: { animation: 26 }
			},
			{
				path: 'followup-fct/:caseId/:followId', component: FollowupFCTComponent, data: { animation: 27 }
			},
			{
				path: 'registered-candidates', component: RegisteredCandidatesComponent, data: { animation: 28 }
			},
		]
	},
	{
		path: 'comp', component: CompanyNavbarComponent, canActivate: [companyGuard], children: [
			{ path: 'dashboard', component: CompanyDashboardComponent, data: { animation: 2 } },
			{ path: 'list-appointment', component: CompanyApptListComponent, data: { animation: 6 } },
			{
				path: 'appt-details/:uId', component: CompanyApptDetailsComponent, data: { animation: 9 }, children: [
					{
						path: ':id', component: CompanyFollowupDetailsComponent, data: { animation: 10 }
					}
				]
			},
			{
				path: 'file-preview', component: FilePreviewComponent, data: { animation: 11 }
			},
		]
	},
	{ path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
